var _rect, _rect2, _rect3, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGenerateImageAi = function SvgGenerateImageAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "url(#generate-image-ai_svg__a)",
    fillOpacity: 0.16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#E4E4E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17 18-3-3m5.01-7.5V6m3.94 3.06L24.01 8m-1.06 9 1.06 1.06m-9-9L13.95 8m10.56 5h1.5M10.131 24.869l9.238-9.238c.396-.396.594-.594.668-.822a1 1 0 0 0 0-.618c-.074-.228-.272-.426-.668-.822l-.738-.738c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0c-.228.074-.426.272-.822.668L7.13 21.87c-.396.396-.594.594-.668.822a1 1 0 0 0 0 .618c.074.228.272.426.668.822l.738.738c.396.396.594.594.822.668a1 1 0 0 0 .618 0c.228-.074.426-.272.822-.668Z",
    stroke: "url(#generate-image-ai_svg__b)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "generate-image-ai_svg__a",
    x1: 32,
    y1: 0.057,
    x2: -6.55,
    y2: 17.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B99CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E7ECFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4467F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "generate-image-ai_svg__b",
    x1: 9.58,
    y1: 16.401,
    x2: 24.805,
    y2: 15.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4664FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#966CDB"
  })))));
};

export default SvgGenerateImageAi;